import { c as _c } from "react/compiler-runtime";
import { MarkdownText } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type InstructionsCalloutProps = {
  instructions: string[];
};

// Deliberately not an InlineAlert: ValidationAlerts renders those directly above, and these
// guardrails are standing scope limits, not a problem to fix. Rendered as markdown so backticked
// field references read the same here as they do in the prompt above.
const InstructionsCallout = t0 => {
  const $ = _c(12);
  const {
    instructions
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.managed.instructions"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  if (instructions.length === 0) {
    return null;
  }
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <span className="text-caption-3 font-medium text-tertiary">{t2}</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== instructions) {
    t4 = instructions.map(_temp2).join("\n");
    $[5] = instructions;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <div className="text-body-3 text-secondary"><MarkdownText>{t4}</MarkdownText></div>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <div className="flex flex-col gap-2 rounded p-3 bg-secondary border border-tertiary">{t3}{t5}</div>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default InstructionsCallout;
function _temp($) {
  return $.label;
}
function _temp2(instruction) {
  return `- ${instruction}`;
}